import { render, staticRenderFns } from "./TosContent.vue?vue&type=template&id=89b15b4a"
import script from "./TosContent.vue?vue&type=script&lang=js"
export * from "./TosContent.vue?vue&type=script&lang=js"
import style0 from "./TosContent.vue?vue&type=style&index=0&id=89b15b4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports